export default {
    props: {
        scrollableDistance: {
            type: Number,
            default: undefined,
            kComposite: 'scrollable.distance'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/Common/Scrollable.js